import { Link } from 'react-router-dom';
import { asset } from '../assets';
import { useLanguage } from './LanguageProvider';

export function SiteFooter() {
  const { t } = useLanguage();

  return (
    <footer className="site-footer">
      <div className="container footer-grid">
        <div className="footer-col">
          <img src={asset('assets/logoyellow.png')} alt="Ingaz 4 Print" className="footer-logo" />
          <p>{t(
            'Your trusted partner for high-quality digital printing solutions in Cairo.',
            'شريكك الموثوق لحلول الطباعة الرقمية عالية الجودة في القاهرة.',
          )}</p>
          <div className="social-icons">
            <a href="https://www.facebook.com/" aria-label="Facebook"><img src={asset('assets/facebook.svg')} alt="" /></a>
            <a href="https://www.instagram.com/" aria-label="Instagram"><img src={asset('assets/instagram.svg')} alt="" /></a>
            <a href="https://www.linkedin.com/" aria-label="LinkedIn"><img src={asset('assets/linkedin.svg')} alt="" /></a>
          </div>
        </div>
        <div className="footer-col">
          <h4>{t('Quick Links', 'روابط سريعة')}</h4>
          <ul>
            <li><Link to="/#products">{t('Products', 'المنتجات')}</Link></li>
            <li><Link to="/#quote">{t('Contact', 'اتصل بنا')}</Link></li>
          </ul>
        </div>
        <div className="footer-col">
          <h4>{t('Contact Us', 'اتصل بنا')}</h4>
          <div className="contact-item">
            <img src={asset('assets/location.svg')} alt="" className="contact-icon" />
            <span>{t('Nasr City, Cairo, Egypt', 'مدينة نصر، القاهرة، مصر')}</span>
          </div>
          <div className="contact-item">
            <img src={asset('assets/email.svg')} alt="" className="contact-icon" />
            <span>CS@Ingaz4Print.com</span>
          </div>
        </div>
      </div>
      <div className="footer-bottom">
        <div className="footer-divider" />
        <p>{t('© 2026 INGAZ 4 Print. All rights reserved.', '© 2026 INGAZ 4 Print. جميع الحقوق محفوظة.')}</p>
      </div>
    </footer>
  );
}
